/* src/components/pages/Login.jsx - Última MOdificación: 07-01-2026 */
/* ----------- Autenticación de Overwatch ------------------------- */

import React, { useState, useRef, useEffect, useMemo } from 'react';
import { Typography, Dialog, DialogTitle, DialogContent,
         DialogActions, Button, Divider, Box, useTheme,
         alpha, TextField, IconButton, InputAdornment } from '@mui/material';

import { ThemeProvider, createTheme } from '@mui/material/styles';
import { getCustomTheme } from '../../theme/customTheme';
import CssBaseline from '@mui/material/CssBaseline';

import { useNavigate } from 'react-router-dom';
import { RiUserLine, RiLock2Line, RiEyeLine, RiEyeOffLine, RiVideoFill } from "react-icons/ri";

import RegistrarCliente from "./Registrarcliente.jsx";
import RegistrarAsociado from "./Registrarasociado.jsx";

import { v4 as uuidv4 } from 'uuid';
import { useAuth } from '../../context/AuthContext.jsx';

import api from '../../services/api'; // api interceptor
import { useFeedback } from '../../context/FeedbackContext.jsx';

const Login = ( ) => {
  const { login } = useAuth();

  const theme = useTheme();

  const version = process.env.REACT_APP_VERSION; // leida desde archivo .env

  const { showFeedback } = useFeedback(); // Mensajes breves no bloqueantes
  const [openRegistroSuccess, setOpenRegistroSuccess] = useState(false); // Exito en registro nuevo
  const [registroSuccessTipo, setRegistroSuccessTipo] = useState(null);  // 'cliente' | 'asociado'

  const [openCodigoError, setOpenCodigoError] = useState(false);    // Dialog MUI
  const [tituloCodigoError, setTituloCodigoError] = useState('');   // Dialog MUI
  const [mensajeCodigoError, setMensajeCodigoError] = useState(''); // Dialog MUI
  const [openPasswordSuccess, setOpenPasswordSuccess] = useState(false); // Exito cambio de contraseña

  const [showNewPassword, setShowNewPassword] = useState(false);         // ver contraseña ingresada
  const [showConfirmPassword, setShowConfirmPassword] = useState(false); // ver contraseña ingresada

  const [usuario, setUsuario] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [newPassword, setNewPassword] = useState(''); // nueva contraseña ingresada
  const [confirmPassword, setConfirmPassword] = useState(''); // confirmar la nueva contraseña ingresada
  const [codeVerified, setCodeVerified] = useState(false); // verficación de código
  const [emailRecuperacion, setEmailRecuperacion] = useState('');
  // const [nombreRecuperacion, setNombreRecuperacion] = useState('');

  const [enteredCode, setEnteredCode] = useState(["", "", "", "", "", ""]);
  const inputRefs = useRef([]);
  const usuarioRef = useRef(null);   // 👈 referencia al input usuario //
  const [isTyping, setIsTyping] = useState(false);
  const typingTimerRef = useRef(null);

  /* 📝 Registro de cliente */
  const [showRegistroModal, setShowRegistroModal] = useState(false);
  const [emailRegistro, setEmailRegistro] = useState('');
  const [codigoRegistro, setCodigoRegistro] = useState(["", "", "", "", "", ""]);
  const inputRefsRegistro = useRef([]);
  const [stepRegistro, setStepRegistro] = useState("email"); // "email" | "codigo" | "form"
  const [timeLeftRegistro, setTimeLeftRegistro] = useState(0);
  const [uniqueId, setuniqueId] = useState('');
  const [registroTipo, setRegistroTipo] = useState(""); // quien solicita registarse "cliente" | "asociado"

  /* ⏰ Timeout configurable desde .env (default 120s) */
  const forgotTimeout = parseInt(process.env.REACT_APP_FORGOT_TIMEOUT || "120", 10);
  const [timeLeft, setTimeLeft] = useState(0); // ⏳ Estado para el contador

  /* 👇 Tema dark para navegacion publica */
  const publicTheme = useMemo(() => {
    const baseTheme = createTheme();
    return createTheme(getCustomTheme(baseTheme, 'dark'));
  }, []);

  /* 👇 Al montar el componente, poner el foco en el campo usuario */
  useEffect(() => {
    if (usuarioRef.current) {
      usuarioRef.current.focus();
    }
  }, []);

  /* Definiendo el efecto de audio para el boton inciar sesion */
  const loginAudioRef = useRef(null);
  useEffect(() => {
    /* este sonido será diferente al click del timer */
    loginAudioRef.current = new Audio("/click_buttons.mp3"); 
    loginAudioRef.current.volume = 0.1; 
  }, []);

  /* Definiendo el efecto de audio para el contador */
  const audioRef = useRef(null);
  useEffect(() => {
    audioRef.current = new Audio("/click_counter.mp3"); // tu MP3 en public/
    audioRef.current.volume = 0.1;
  }, []);


  /* 🔊 Dígito con efecto clic/cassette + sonido */
  const Digit = ({
    value,
    digitHeight = 36,
    digitWidth = 28,
    danger = false,
  }) => {
    const theme = useTheme();
    const [prevValue, setPrevValue] = useState(value);
    const [clicked, setClicked] = useState(false);

    useEffect(() => {
      if (value !== prevValue) {
        setClicked(true);
        setPrevValue(value);

        const timer = setTimeout(() => setClicked(false), 150);
        return () => clearTimeout(timer);
      }
    }, [value, prevValue]);

    const fontSize = digitHeight * 0.85;

    const glowColor = danger
      ? theme.palette.error.main
      : theme.palette.success.main;

    return (
      <Box
        sx={{
          width: digitWidth,
          height: digitHeight,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',

          fontFamily: theme.typography.fontFamily,
          fontWeight: 700,
          fontSize,
          letterSpacing: '2px',

          color: glowColor,
          textShadow: `
            0 0 6px ${alpha(glowColor, 0.6)},
            0 0 10px ${alpha(glowColor, 0.9)}
          `,

          transform: clicked ? 'scale(1.1)' : 'scale(1)',
          transition: 'transform 150ms ease',
          userSelect: 'none',
        }}
      >
        {value}
      </Box>
    );
  };

  /* ⏱ Timer con sonido y cambio a rojo faltando 5 seg */
  const CassetteTimer = ({
    time,
    digitHeight = 24,
    digitWidth = 18,
    onExpire,
    isTyping,
  }) => {
    const theme = useTheme();
    const [danger, setDanger] = useState(false);
    const audioRef = useRef(null);

    /* cargar sonido de click */
    useEffect(() => {
      audioRef.current = new Audio('/click_counter.mp3');
      audioRef.current.volume = 0.1;
    }, []);

    const playClick = () => {
      if (audioRef.current) {
        audioRef.current.currentTime = 0;
        audioRef.current.play().catch(() => {});
      }
    };

    /* 🚨 efecto peligro y expiración */
    useEffect(() => {
      if (time <= 5 && time > 0) {
        setDanger(true);
      }

      if (time === 0 && onExpire) {
        const timer = setTimeout(() => onExpire(), 1000);
        return () => clearTimeout(timer);
      }

      if (time > 0 && !isTyping) {
        playClick();
      }
    }, [time, onExpire, isTyping]);

    const minutes = Math.floor(time / 60)
      .toString()
      .padStart(2, '0')
      .split('');

    const seconds = (time % 60).toString().padStart(2, '0').split('');

    const baseColor = danger
      ? theme.palette.error.main
      : theme.palette.success.main;

    return (
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 0.5,
          px: 1.5,
          py: 0.75,
          borderRadius: 1.5,

          backgroundColor: alpha(theme.palette.background.paper, 0.6),
          border: `1px solid ${alpha(baseColor, 0.4)}`,
          boxShadow: `inset 0 0 12px ${alpha(baseColor, 0.25)}`,

          ...(danger && time === 0 && {
            animation: 'pulse 1.2s infinite',
          }),

          '@keyframes pulse': {
            '0%': { boxShadow: `0 0 0 0 ${alpha(baseColor, 0.6)}` },
            '70%': { boxShadow: `0 0 0 6px ${alpha(baseColor, 0)}` },
            '100%': { boxShadow: `0 0 0 0 ${alpha(baseColor, 0)}` },
          },
        }}
      >
        {minutes.map((d, i) => (
          <Digit
            key={`m-${i}`}
            value={parseInt(d, 10)}
            digitHeight={digitHeight}
            digitWidth={digitWidth}
            danger={danger}
          />
        ))}

        {/* Separador ":" */}
        <Box
          sx={{
            mx: 0.5,
            fontFamily: 'monospace',
            fontSize: 14,
            fontWeight: 600,
            color: baseColor,
            textShadow: `
              0 0 6px ${alpha(baseColor, 0.6)},
              0 0 10px ${alpha(baseColor, 0.9)}
            `,
            userSelect: 'none',
          }}
        >
          :
        </Box>

        {seconds.map((d, i) => (
          <Digit
            key={`s-${i}`}
            value={parseInt(d, 10)}
            digitHeight={digitHeight}
            digitWidth={digitWidth}
            danger={danger}
          />
        ))}
      </Box>
    );
  };

  /* Efecto para el timer */
  useEffect(() => {
    if (showModal && !codeVerified && timeLeft > 0) {
      const timer = setInterval(() => setTimeLeft((prev) => prev - 1), 1000);
      return () => clearInterval(timer);
    }
    if (timeLeft === 0 && showModal && !codeVerified) {
      /* 🔴 tiempo agotado → cancelar y anular clave temporal */
      (async () => {
        try {
          const fixRut = usuario.padStart(10, '0').toUpperCase();

          await api.post('/auth/anularclavetmp', {
            usuario: fixRut
          });

        } catch (error) {
          console.error("Error al anular clave temporal:", error);
        }
      })();

      // Limpiar estados después de la llamada //
      setCodeVerified(false);
      setNewPassword('');
      setConfirmPassword('');
      setEnteredCode(["", "", "", "", "", ""]);
      setShowModal(false);
      setuniqueId('');
      
      showFeedback({
        message: 'El tiempo para ingresar el código expiró. Intenta nuevamente.',
        severity: 'error',
      });
    }
  }, [timeLeft, showModal, codeVerified, usuario, showFeedback]);

  /* ⏰ Timer para registro */
  useEffect(() => {
    if (showRegistroModal && stepRegistro === "codigo" && timeLeftRegistro > 0) {
      const timer = setInterval(() => setTimeLeftRegistro(prev => prev - 1), 1000);
      return () => clearInterval(timer);
    }
  }, [showRegistroModal, stepRegistro, timeLeftRegistro]);

  /* 🔊 Efecto de sonido */
  const reproducirSonidoLogin = () => {
    if (loginAudioRef.current) {
      loginAudioRef.current.currentTime = 0;
      loginAudioRef.current
        .play()
        .catch(err => console.log('Error reproduciendo sonido de login:', err));
    }
  };

  /* 📝 Manejo de inputs de código */
  const handleInputChangeRegistro = (index, value) => {
    if (!/^[0-9]?$/.test(value)) return;
    const newCode = [...codigoRegistro];
    newCode[index] = value;
    setCodigoRegistro(newCode);
    if (value && index < 5) {
      inputRefsRegistro.current[index + 1]?.focus();
    }

    /* Silenciar sonido inmediatamente */
    setIsTyping(true);

    /* Reiniciar el temporizador de reactivación */
    if (typingTimerRef.current) clearTimeout(typingTimerRef.current);

    /* Activar sonido nuevamente después de 60s sin escribir */
    typingTimerRef.current = setTimeout(() => {
      setIsTyping(false);
    }, 10000); // 10 segundos
  };

  /* 👀 Ingreso de numeros a verificar */
  const handleKeyDownRegistro = (index, e) => {
    if (e.key === "Backspace" && !codigoRegistro[index] && index > 0) {
      inputRefsRegistro.current[index - 1]?.focus();
    }
    if (typingTimerRef.current) {
      clearTimeout(typingTimerRef.current);
    }
    typingTimerRef.current = setTimeout(() => setIsTyping(false), 2000); // 1s sin escribir = no typing
  };

  const codeAsStringRegistro = codigoRegistro.join("");

  const isValidEmail = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };

  //* ✉️ Enviar correo para registro */
  const handleEnviarCorreoRegistro = async () => {
    const email = emailRegistro.trim();

    /* email vacío */
    if (!email) {
      showFeedback({
        severity: 'warning',
        message: 'Debe ingresar un correo electrónico',
      });
      return;
    }

    /* formato email no válido */
    if (!isValidEmail(email)) {
      showFeedback({
        severity: 'warning',
        message: 'El correo electrónico no tiene un formato válido',
      });
      return;
    }

    try {
      const uid = uuidv4();
      setuniqueId(uid); // Generar un ID único para la solicitud de registro //

      const response = await api.post('/registrarse/solicitudregistro', {
        uuidReg: uid,
        correoReg: emailRegistro,
        tipoReg: registroTipo
      });

      if (response.data.success) {
        setStepRegistro("codigo");
        setTimeLeftRegistro(forgotTimeout);

        showFeedback({
          message: 'Se ha enviado un código de autorización, revise su correo',
          severity: 'success',
        });
      }
    } catch (err) {
      showFeedback({
        message: 'No fue posible enviar el código de recuperación',
        severity: 'error',
      });
    }
  };

  /* 📌 Verificar código de autorización para registro */
  const handleVerificarCodigoRegistro = async () => {
    const titleRegistro = registroTipo === "asociado" 
      ? "Registro de Asociado" 
      : "Registro de Cliente";

    try {
      const response = await api.post('/registrarse/getcodigoautorizacion', {
        uuidReg: uniqueId
      });

      if (response.data.success) {
        const codigoEnviado = response.data.rows?.[0]?.clavetmp_reg || '';

        if (codeAsStringRegistro === codigoEnviado) {
          if (registroTipo === "cliente") {
            setStepRegistro("formCliente");
          } else if (registroTipo === "asociado") {
            setStepRegistro("formAsociado");
          }
        } else {
          setTituloCodigoError(titleRegistro);
          setMensajeCodigoError("El código ingresado es incorrecto");
          setOpenCodigoError(true);
        }
      }
    } catch (err) {
      setTituloCodigoError(titleRegistro);
      setMensajeCodigoError("Error al verificar código");
      setOpenCodigoError(true);
    }
  };

  /* 🔄 Cancelar solicitud de registro */
  const handleEliminarSolicitud = async (uniqueId) => {
    try {
      /* Verificamos si uniqueId existe y no está vacío */
      if (!uniqueId || uniqueId.trim() === "") {
        return; // salir sin llamar al backend //
      }

      await api.post('/registrarse/eliminarsolicitud', {
        uuidReg: uniqueId
      });

    } catch (error) {
      console.error("Error al eliminar solicitud de registro:", error);

    } finally {
      setShowRegistroModal(false);
      setStepRegistro("email");
      setEmailRegistro('');
      setuniqueId('');
      setCodigoRegistro(["", "", "", "", "", ""]);
      setTimeLeftRegistro(0);
    }
  };

  /* 🔄 Cancelar de ficha de registro */
  const handleCancelarRegistro = async () => {
    setShowRegistroModal(false);
    setStepRegistro("email");
    setEmailRegistro('');
    setuniqueId('');
    setCodigoRegistro(["", "", "", "", "", ""]);
    setTimeLeftRegistro(0);
  };

  /* 🔑 Enviando solicitud de Login */
  const handleSubmit = async (e) => {
    e.preventDefault();

    reproducirSonidoLogin();

    if (!validarRut(usuario)) {
      showFeedback({
        message: 'El RUT ingresado no es válido',
        severity: 'error',
      });
      return;
    }

    try {
      const fixRut = usuario.padStart(10, '0').toUpperCase();

      const { data } = await api.post('/auth/login', {
        usuario_usr: fixRut,
        password_usr: password,
      });

      login(data.token); // 🔥 AQUÍ SE ACTIVA TODO
      navigate('/');

    } catch (error) {
      showFeedback({
        message: 'Credenciales inválidas o usuario deshabilitado',
        severity: 'error',
      });
    };
  };

  /* 🛠️ Validación del Rut (Módulo 11) */
  const validarRut = (rut) => {
    let valor = rut.replace(/\./g, '').replace('-', '');
    let cuerpo = valor.slice(0, -1);
    let dv = valor.slice(-1).toUpperCase();
    let suma = 0;
    let multiplo = 2;

    for (let i = 1; i <= cuerpo.length; i++) {
      let index = multiplo * valor.charAt(cuerpo.length - i);
      suma += index;
      multiplo = multiplo < 7 ? multiplo + 1 : 2;
    }

    let dvEsperado = 11 - (suma % 11);
    dvEsperado = dvEsperado === 11 ? '0' : dvEsperado === 10 ? 'K' : dvEsperado.toString();
    return dv === dvEsperado;
  };

  /* 🛠️ Manejo para ingresar los 6 numeros del codigo de seguridad */
  const handleInputChange = (index, value) => {
    setIsTyping(true);
    if (!/^[0-9]?$/.test(value)) return; // Solo permitir números
    const newCode = [...enteredCode];
    newCode[index] = value;
    setEnteredCode(newCode);
  
    if (value && index < 5) {
      inputRefs.current[index + 1]?.focus();
    }
    if (typingTimerRef.current) {
      clearTimeout(typingTimerRef.current);
    }
    typingTimerRef.current = setTimeout(() => setIsTyping(false), 2000);
  };
  
  const handleKeyDown = (index, e) => {
    if (e.key === "Backspace" && !enteredCode[index] && index > 0) {
      inputRefs.current[index - 1]?.focus();
    }
  };
  
  const codeAsString = enteredCode.join(""); // Para usar en la verificación

  /* 🛠️ Mascara para email */
  const enmascararEmail = (email) => {
    const [usuario, dominio] = email.split('@');
    if (!usuario || !dominio) return '';
    const visible = usuario.slice(0, 2);
    const oculto = '*'.repeat(Math.max(usuario.length - 2, 3));
    return `${visible}${oculto}@${dominio}`;
  };

  /* 🔄 Cancelar cambio de contraseña */
  const handleCancel = async (usuario) => {
    try {
      const fixRut = usuario.padStart(10, '0').toUpperCase();

      await api.post('/auth/anularclavetmp', {
        usuario: fixRut
      });

    } catch (error) {
      console.error("Error al anular clave temporal:", error);
    }
    /* Limpiar estados después de la llamada */
    setCodeVerified(false);
    setNewPassword('');
    setConfirmPassword('');
    setEnteredCode(["", "", "", "", "", ""]);
    setShowModal(false);
    setuniqueId('');
  };

  /* 🔔 Manejo cambio de contraseña por olvido */
  const handleForgotPassword = async () => {
    if (!usuario) {
      showFeedback({
        message: 'Debe ingresar el RUT para recuperar su contraseña',
        severity: 'warning',
      });
      return;
    }

    /* Validar rut */
    const usuarioValidado = validarRut(usuario);
    if (!usuarioValidado) {
      showFeedback({
        message: 'El rut ingresado no es valido, intente nuevamente.',
        severity: 'warning',
      });
      return;
    }

    try {
      const fixRut = usuario.padStart(10, '0').toUpperCase();

      const response = await api.post('/auth/forgotpassword', {
        usuario: fixRut
      });

      if (response.data.success) {
        const email = response.data.rows?.[0]?.email_cli || '';
        // const nombre = response.data.rows?.[0]?.nombre_cli || '';
        setEmailRecuperacion(email);
        // setNombreRecuperacion(nombre);
        setShowModal(true);
        setTimeLeft(forgotTimeout); // ⏳ activando timer //
      }

    } catch (error) {
      if (error.response && error.response.status === 404) {
        showFeedback({
          message: 'No fue posible validar la información ingresada',
          severity: 'error',
        });

      } else {
        if (error.response && error.response.status === 400) {
          showFeedback({
            message: 'El Usuario no tiene el Email informado, no puede continuar con la recuperación.',
            severity: 'error',
          });
    
        } else {
          showFeedback({
            message: 'Ocurrió un error al procesar la solicitud, intente mas tarde',
            severity: 'error',
          });
        }
      }
    }
  };

  /* 🛠️ Verificar el codigo ingresado */
  const handleVerifyCode = async () => {
    try {
      const fixRut = usuario.padStart(10, '0').toUpperCase();

      const response =  await api.post('/auth/getcodigoautorizacion', {
        usuario: fixRut
      });

      if (response.data.success) {
        const claveenviada = response.data.rows?.[0]?.clavetmp_usr || '';

        if (codeAsString === claveenviada) {
          setCodeVerified(true);
          setTimeLeft(0); // ✅ detener contador //

        } else {
          showFeedback({
            message: 'El Código ingresado es incorrecto.',
            severity: 'error',
          });
        }
      };

    } catch (error) {
      if (error.response && error.response.status === 404) {
        showFeedback({
          message: 'No fue posible validar la información ingresada',
          severity: 'error',
        });

      } else {
        if (error.response && error.response.status === 400) {
          showFeedback({
            message: 'Debe solicitar el Código de Autorización.',
            severity: 'error',
          });
    
        } else {
          showFeedback({
            message: 'Ocurrió un error al procesar la solicitud, intente mas tarde',
            severity: 'error',
          });
        }
      }
    }
  };

  /* 🛠️ Cambio de contraseña */
  const handleChangePassword = async () => {
    if (newPassword.trim() !== confirmPassword.trim()) {
      showFeedback({
        message: 'Las contraseñas ingresadas no coinciden',
        severity: 'error',
      });
 
    }
    if (newPassword.trim() === confirmPassword.trim()) {
      try {
        const fixRut = usuario.padStart(10, '0').toUpperCase();

        const response = await api.post('/auth/resetpassword', {
          usuario: fixRut,
          newPassword: newPassword
        });

        if (response.data.success) {
          setOpenPasswordSuccess(true);
        }

      } catch (error) {
        if (error.response && error.response.status === 404) {
          showFeedback({
            message: 'No fue posible validar la información ingresada',
            severity: 'error',
          });
    
        } else {
          showFeedback({
            message: 'Ocurrió un error al procesar la solicitud, intente mas tarde',
            severity: 'error',
          });
        }
      }
    }
  };


  /* Render */
  return (
  <ThemeProvider theme={publicTheme}>
    <CssBaseline />
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',

          backgroundImage: 'url("/fondo_pantalla.jpg")',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          backgroundPosition: 'center',

          // overlay sutil para legibilidad (opcional pero recomendado)
          position: 'relative',

          '&::before': {
            content: '""',
            position: 'absolute',
            inset: 0,
            backgroundColor: alpha('#000', 0.35), // 👈 oscurece un poco el fondo
            zIndex: 0,
          },
        }}
      >
        {/* Contenido */}
        <Box sx={{ position: 'relative', zIndex: 1 }}>
          <Box
            sx={{
              width: 380,
              p: 4,
              borderRadius: 3,
              backdropFilter: 'blur(12px)',
              backgroundColor: alpha(theme.palette.common.white, 0.15),
              border: `1px solid ${alpha(theme.palette.common.white, 0.25)}`,
              boxShadow: '0 25px 50px rgba(0,0,0,0.35)',
            }}
          >
            {/* Título */}
            <Typography
              variant="h5"
              fontWeight={800}
              textAlign="center"
              color="common.white"
              gutterBottom
              sx={{ letterSpacing: 1 }}
            >
              INICIAR SESIÓN
            </Typography>

            {/* Marca */}
            <Box display="flex" justifyContent="center" mb={3}>
              <Typography
                variant="subtitle1"
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1,
                  color: 'common.white',
                  opacity: 0.9,
                }}
              >
                <RiVideoFill size={20} color="#F5A53D" />
                OverWatch
                <Typography variant="caption" sx={{ opacity: 0.75, ml: 0.5 }}>
                  v{version}
                </Typography>
              </Typography>
            </Box>

            <form onSubmit={handleSubmit}>
              {/* Usuario */}
              <Typography
                variant="subtitle2"
                sx={{
                  color: 'common.white',
                  fontWeight: 600,
                  mb: 0.5,
                }}
              >
                Usuario
              </Typography>

              <TextField
                value={usuario}
                onChange={(e) => setUsuario(e.target.value.toUpperCase())}
                fullWidth
                placeholder="Ingrese su RUT"
                autoComplete="off"
                slotProps={{
                  input: {
                    startAdornment: (
                      <InputAdornment position="start">
                        <RiUserLine />
                      </InputAdornment>
                    ),
                    sx: {
                      backgroundColor: alpha(theme.palette.common.white, 0.12),
                      borderRadius: 2,
                      color: 'white',
                    },
                  },
                }}
                sx={{
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: alpha(theme.palette.common.white, 0.3),
                  },
                  '& input::placeholder': {
                    color: alpha(theme.palette.common.white, 0.6),
                  },
                }}
              />

              {/* Contraseña */}
              <Typography
                variant="subtitle2"
                sx={{
                  color: 'common.white',
                  fontWeight: 600,
                  mb: 0.5,
                  mt: 2,
                }}
              >
                Contraseña
              </Typography>

              <TextField
                type={showPassword ? 'text' : 'password'}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                fullWidth
                placeholder="Ingrese su contraseña"
                autoComplete="off"
                slotProps={{
                  input: {
                    startAdornment: (
                      <InputAdornment position="start">
                        <RiLock2Line />
                      </InputAdornment>
                    ),
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() => setShowPassword((p) => !p)}
                          edge="end"
                          sx={{ color: 'white' }}
                        >
                          {showPassword ? <RiEyeOffLine /> : <RiEyeLine />}
                        </IconButton>
                      </InputAdornment>
                    ),
                    sx: {
                      backgroundColor: alpha(theme.palette.common.white, 0.12),
                      borderRadius: 2,
                      color: 'white',
                    },
                  },
                }}
                sx={{
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: alpha(theme.palette.common.white, 0.3),
                  },
                  '& input::placeholder': {
                    color: alpha(theme.palette.common.white, 0.6),
                  },
                }}
              />
              {/* Botón */}
              <Button
                type="submit"
                fullWidth
                size="large"
                variant="contained"
                sx={{
                  mt: 3,
                  borderRadius: 2,
                  fontWeight: 700,
                  letterSpacing: 0.5,
                }}
              >
                Iniciar Sesión
              </Button>

              {/* Recuperar */}
              <Typography
                variant="body2"
                textAlign="center"
                mt={2}
                sx={{
                  cursor: 'pointer',
                  color: theme.palette.primary.light,
                  '&:hover': { textDecoration: 'underline' },
                }}
                onClick={handleForgotPassword}
              >
                ¿Has olvidado tu contraseña?
              </Typography>

              {/* Registro */}
              <Box display="flex" justifyContent="space-between" mt={2}>
                <Typography
                  variant="body2"
                  sx={{ cursor: 'pointer', '&:hover': { textDecoration: 'underline' } }}
                  onClick={() => {
                    setRegistroTipo("cliente");
                    setShowRegistroModal(true);
                  }}
                >
                  ◆ Registrarse como Cliente
                </Typography>

                <Typography
                  variant="body2"
                  textAlign="right"
                  sx={{ cursor: 'pointer', '&:hover': { textDecoration: 'underline' } }}
                  onClick={() => {
                    setRegistroTipo("asociado");
                    setShowRegistroModal(true);
                  }}
                >
                  ◆ Incorporación Cliente/Proveedor
                </Typography>
              </Box>
            </form>
          </Box>

          {/* Modal solicitud de Registro */}
          {showRegistroModal && (
            <Box
              sx={{
                position: 'fixed',
                inset: 0,
                zIndex: 1300,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: 'rgba(0,0,0,0.4)',
              }}
            >
              <Box
                sx={{
                  width: 400,
                  p: 3,
                  borderRadius: 3,
                  backdropFilter: 'blur(12px)',
                  backgroundColor: alpha(theme.palette.background.paper, 0.85),
                  border: `1px solid ${alpha(theme.palette.divider, 0.3)}`,
                  boxShadow: '0 30px 60px rgba(0,0,0,0.5)',
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 2,
                }}
              >
                {stepRegistro === 'email' && (
                  <>
                    <Typography
                      variant="h6"
                      fontWeight={700}
                      textAlign="center"
                      color="primary.main"
                    >
                      {registroTipo === 'cliente'
                        ? 'Registro de Cliente'
                        : 'Registro de Asociado'}
                    </Typography>

                    <Typography
                      variant="body2"
                      textAlign="center"
                      sx={{
                        color: (theme) => theme.palette.warning.light,
                        fontWeight: 500,
                        letterSpacing: '0.2px',
                        lineHeight: 1.6,
                      }}
                    >
                      Ingrese su correo electrónico
                      <br />
                      Le enviaremos un código de verificación
                    </Typography>

                    <TextField
                      type="email"
                      value={emailRegistro}
                      onChange={(e) => setEmailRegistro(e.target.value)}
                      fullWidth
                      autoFocus
                      sx={{
                        '& .MuiOutlinedInput-root': {
                          borderRadius: 2,
                          backgroundColor: alpha(theme.palette.common.white, 0.08),
                        },
                      }}
                    />

                    <Box display="flex" justifyContent="space-between" mt={1}>
                      <Button
                        variant="contained"
                        onClick={handleEnviarCorreoRegistro}
                        sx={{ width: 140 }}
                      >
                        Enviar
                      </Button>

                      <Button
                        variant="outlined"
                        color="inherit"
                        onClick={handleCancelarRegistro}
                        sx={{ width: 140 }}
                      >
                        Cancelar
                      </Button>
                    </Box>
                  </>
                )}

                {stepRegistro === 'codigo' && (
                  <>
                    <Typography
                      variant="h6"
                      fontWeight={700}
                      textAlign="center"
                      color="primary.main"
                    >
                      Verifica tu código
                    </Typography>

                    <Typography
                      variant="body2"
                      textAlign="center"
                      color="text.secondary"
                      sx={{
                        color: (theme) => theme.palette.warning.light,
                        fontWeight: 500,
                        letterSpacing: '0.2px',
                        lineHeight: 1.6,
                      }}
                    >
                      Se ha enviado un código a:
                      <br />
                      <strong>{emailRegistro}</strong>
                    </Typography>

                    {/* ⏳ Timer */}
                    <Box display="flex" justifyContent="center" mt={1}>
                      <CassetteTimer
                        time={timeLeftRegistro}
                        digitHeight={36}
                        digitWidth={28}
                        onExpire={() => handleEliminarSolicitud(uniqueId)}
                        isTyping={isTyping}
                      />
                    </Box>

                    {/* Inputs código */}
                    <Box
                      sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        gap: 1,
                        p: 1.5,
                        borderRadius: 2,
                        backgroundColor: alpha(theme.palette.common.black, 0.3),
                        border: `1px solid ${alpha(theme.palette.divider, 0.3)}`,
                      }}
                    >
                      {codigoRegistro.map((digit, index) => (
                        <Box
                          key={index}
                          component="input"
                          ref={(el) => (inputRefsRegistro.current[index] = el)}
                          value={digit}
                          maxLength={1}
                          inputMode="numeric"
                          onChange={(e) =>
                            handleInputChangeRegistro(index, e.target.value)
                          }
                          onKeyDown={(e) => handleKeyDownRegistro(index, e)}
                          sx={{
                            width: 36,
                            height: 44,
                            textAlign: 'center',
                            fontSize: 18,
                            fontWeight: 600,
                            borderRadius: 1.5,
                            border: `1px solid ${alpha(theme.palette.divider, 0.4)}`,
                            backgroundColor: alpha(theme.palette.background.paper, 0.9),
                            color: 'text.primary',
                            outline: 'none',
                            '&:focus': {
                              borderColor: theme.palette.primary.main,
                              boxShadow: `0 0 0 2px ${alpha(
                                theme.palette.primary.main,
                                0.3
                              )}`,
                            },
                          }}
                        />
                      ))}
                    </Box>

                    <Box display="flex" justifyContent="space-between">
                      <Button
                        variant="contained"
                        onClick={handleVerificarCodigoRegistro}
                        sx={{ width: 140 }}
                      >
                        Verificar
                      </Button>

                      <Button
                        variant="outlined"
                        color="inherit"
                        onClick={() => handleEliminarSolicitud(uniqueId)}
                        sx={{ width: 140 }}
                      >
                        Cancelar
                      </Button>
                    </Box>
                  </>
                )}

                {stepRegistro === "formCliente" && (
                  <RegistrarCliente
                    uniqueId={uniqueId}             // ✅ pasamos el ID único
                    onClose={handleCancelarRegistro}
                    onSuccess={() => {
                      setRegistroSuccessTipo('cliente');
                      handleCancelarRegistro();     // cierra modal registro
                      setOpenRegistroSuccess(true); // abre dialog éxito
                    }}
                  />
                )}

                {stepRegistro === "formAsociado" && (
                  <RegistrarAsociado 
                    uniqueId={uniqueId}             // ✅ pasamos el ID único
                    onClose={handleCancelarRegistro} 
                    onSuccess={() => {
                      setRegistroSuccessTipo('asociado');
                      handleCancelarRegistro();     // cierra modal registro
                      setOpenRegistroSuccess(true); // abre dialog éxito
                    }}
                  />
                )}

                <Divider sx={{ my: 1 }} />

                <Box display="flex" justifyContent="center" alignItems="center" gap={1}>
                  <RiVideoFill size={18} color="#F5A53D" />
                  <Typography variant="caption" color="text.secondary">
                    OverWatch
                  </Typography>
                </Box>

              </Box>
            </Box>
          )}


          {/* Modal de recuperación contraseña */}
          {showModal && (
            <Box
              sx={{
                position: 'fixed',
                inset: 0,
                zIndex: 1300,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: 'rgba(0,0,0,0.4)',
              }}
            >
              <Box
                sx={{
                  width: 400,
                  minHeight: 500,
                  p: 3,
                  borderRadius: 3,
                  backdropFilter: 'blur(14px)',
                  backgroundColor: alpha(theme.palette.background.paper, 0.9),
                  border: `1px solid ${alpha(theme.palette.divider, 0.3)}`,
                  boxShadow: '0 30px 60px rgba(0,0,0,0.55)',
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 2,
                }}
              >
                {!codeVerified && (
                  <>
                    <Typography
                      variant="h6"
                      fontWeight={700}
                      textAlign="center"
                      color="primary.main"
                    >
                      Verifica tu código
                    </Typography>

                    <Typography
                      variant="body2"
                      textAlign="center"
                      color="text.secondary"
                      lineHeight={1.6}
                    >
                      Hemos enviado un código de verificación a:
                      <br />
                      <strong>{enmascararEmail(emailRecuperacion)}</strong>
                    </Typography>

                    {/* ⏳ Contador */}
                    <Box display="flex" justifyContent="center" mt={1}>
                      <Box
                        sx={{
                          mb:2,
                          px: 2,
                          py: 1,
                          borderRadius: 2,
                          backgroundColor: alpha(theme.palette.common.black, 0.25),
                          border: `1px solid ${alpha(theme.palette.success.main, 0.3)}`,
                        }}
                      >
                        <CassetteTimer
                          time={timeLeft}
                          digitHeight={34}
                          digitWidth={26}
                        />
                      </Box>
                    </Box>

                    {/* Inputs de código */}
                    <Box
                      sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        gap: 1,
                        p: 1.5,
                        borderRadius: 2,
                        backgroundColor: alpha(theme.palette.common.black, 0.3),
                        border: `1px solid ${alpha(theme.palette.divider, 0.3)}`,
                      }}
                    >
                      {enteredCode.map((digit, index) => (
                        <Box
                          key={index}
                          component="input"
                          ref={(el) => (inputRefs.current[index] = el)}
                          value={digit}
                          maxLength={1}
                          inputMode="numeric"
                          onChange={(e) => handleInputChange(index, e.target.value)}
                          onKeyDown={(e) => handleKeyDown(index, e)}
                          sx={{
                            width: 36,
                            height: 44,
                            textAlign: 'center',
                            fontSize: 18,
                            fontWeight: 600,
                            borderRadius: 1.5,
                            border: `1px solid ${alpha(theme.palette.divider, 0.4)}`,
                            backgroundColor: alpha(theme.palette.background.paper, 0.95),
                            color: 'text.primary',
                            outline: 'none',
                            caretColor: 'transparent',
                            '&:focus': {
                              borderColor: theme.palette.primary.main,
                              boxShadow: `0 0 0 2px ${alpha(
                                theme.palette.primary.main,
                                0.3
                              )}`,
                            },
                          }}
                        />
                      ))}
                    </Box>

                    <Box display="flex" justifyContent="space-between">
                      <Button
                        variant="contained"
                        onClick={handleVerifyCode}
                        sx={{ width: 140 }}
                      >
                        Verificar
                      </Button>

                      <Button
                        variant="outlined"
                        color="inherit"
                        onClick={() => handleCancel(usuario)}
                        sx={{ width: 140 }}
                      >
                        Cancelar
                      </Button>
                    </Box>
                  </>
                )}

                {codeVerified && (
                  <>
                    <Typography
                      variant="h6"
                      fontWeight={700}
                      textAlign="center"
                      color="primary.main"
                    >
                      Establecer nueva contraseña
                    </Typography>

                    <Typography
                      variant="caption"
                      textAlign="center"
                      color="text.secondary"
                    >
                      La contraseña debe ser segura y confidencial
                    </Typography>

                    <Divider />

                    {/* Nueva contraseña */}
                    <Typography
                      variant="subtitle2"
                      sx={{
                        color: theme.palette.warning.light,
                        fontWeight: 600,
                        mb: 0.5,
                      }}
                    >
                      Nueva contraseña
                    </Typography>

                    <TextField
                      type={showNewPassword ? 'text' : 'password'}
                      value={newPassword}
                      onChange={(e) => setNewPassword(e.target.value)}
                      fullWidth
                      placeholder="Ingrese la nueva contraseña"
                      autoComplete="off"
                      slotProps={{
                        input: {
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton
                                onClick={() => setShowNewPassword((p) => !p)}
                                edge="end"
                                sx={{ color: 'white' }}
                              >
                                {showNewPassword ? <RiEyeOffLine /> : <RiEyeLine />}
                              </IconButton>
                            </InputAdornment>
                          ),
                          sx: {
                            backgroundColor: alpha(theme.palette.common.white, 0.12),
                            borderRadius: 2,
                            color: 'white',
                          },
                        },
                      }}
                      sx={{
                        '& .MuiOutlinedInput-notchedOutline': {
                          borderColor: alpha(theme.palette.common.white, 0.3),
                        },
                        '& input::placeholder': {
                          color: alpha(theme.palette.common.white, 0.6),
                        },
                      }}
                    />

                    {/* Confirmar contraseña */}
                    <Typography
                      variant="subtitle2"
                      sx={{
                        color: theme.palette.warning.light,
                        fontWeight: 600,
                        mb: 0.5,
                        mt: 2,
                      }}
                    >
                      Confirmar contraseña
                    </Typography>

                    <TextField
                      type={showConfirmPassword ? 'text' : 'password'}
                      value={confirmPassword}
                      onChange={(e) => setConfirmPassword(e.target.value)}
                      fullWidth
                      placeholder="Repita la nueva contraseña"
                      autoComplete="off"
                      slotProps={{
                        input: {
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton
                                onClick={() => setShowConfirmPassword((p) => !p)}
                                edge="end"
                                sx={{ color: 'white' }}
                              >
                                {showConfirmPassword ? <RiEyeOffLine /> : <RiEyeLine />}
                              </IconButton>
                            </InputAdornment>
                          ),
                          sx: {
                            backgroundColor: alpha(theme.palette.common.white, 0.12),
                            borderRadius: 2,
                            color: 'white',
                          },
                        },
                      }}
                      sx={{
                        '& .MuiOutlinedInput-notchedOutline': {
                          borderColor: alpha(theme.palette.common.white, 0.3),
                        },
                        '& input::placeholder': {
                          color: alpha(theme.palette.common.white, 0.6),
                        },
                      }}
                    />

                    <Box display="flex" justifyContent="space-between" mt={1}>
                      <Button
                        variant="contained"
                        onClick={handleChangePassword}
                        sx={{ width: 140 }}
                      >
                        Guardar
                      </Button>

                      <Button
                        variant="outlined"
                        color="inherit"
                        onClick={() => handleCancel(usuario)}
                        sx={{ width: 140 }}
                      >
                        Cancelar
                      </Button>
                    </Box>
                  </>
                )}

                <Divider sx={{ my: 1 }} />

                <Box display="flex" justifyContent="center" alignItems="center" gap={1}>
                  <RiVideoFill size={18} color="#F5A53D" />
                  <Typography variant="caption" color="text.secondary">
                    OverWatch
                  </Typography>
                </Box>
              </Box>
            </Box>
          )}

          {/* Error en el código ingresado */}
          <Dialog
            open={openCodigoError}
            onClose={(_, reason) => {
              if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
                setOpenCodigoError(false);
              }
            }}
            maxWidth="xs"
            fullWidth
            slotProps={{
              paper: {
                sx: {
                  borderRadius: 3,
                  backdropFilter: 'blur(10px)',
                  backgroundColor: alpha(theme.palette.background.paper, 0.95),
                  border: `1px solid ${alpha(theme.palette.divider, 0.3)}`,
                  boxShadow: '0 30px 60px rgba(0,0,0,0.5)',
                },
              },
            }}
          >
            {/* Título */}
            <DialogTitle
              sx={{
                fontWeight: 700,
                textAlign: 'center',
                color: theme.palette.error.main,
                letterSpacing: 0.3,
              }}
            >
              {tituloCodigoError}
            </DialogTitle>

            {/* Mensaje */}
            <DialogContent sx={{ textAlign: 'center', pt: 1 }}>
              <Typography variant="body1" color="text.primary">
                {mensajeCodigoError}
              </Typography>
            </DialogContent>

            {/* Acción */}
            <DialogActions sx={{ justifyContent: 'center', pb: 2 }}>
              <Button
                variant="contained"
                color="error"
                onClick={() => setOpenCodigoError(false)}
                sx={{
                  px: 4,
                  borderRadius: 2,
                  fontWeight: 600,
                }}
              >
                Entendido
              </Button>
            </DialogActions>

            <Divider />

            {/* Footer marca */}
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 1,
                py: 1.5,
                opacity: 0.75,
              }}
            >
              <RiVideoFill size={18} color="#F5A53D" />
              <Typography variant="caption" color="text.secondary">
                OverWatch
              </Typography>
            </Box>
          </Dialog>

          {/* Cotraseña cambiada con exito */}
          <Dialog
            open={openPasswordSuccess}
            onClose={(_, reason) => {
              if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
                setOpenPasswordSuccess(false);
              }
            }}
            maxWidth="xs"
            fullWidth
            slotProps={{
              paper: {
                sx: {
                  borderRadius: 3,
                  backdropFilter: 'blur(10px)',
                  backgroundColor: alpha(theme.palette.background.paper, 0.95),
                  border: `1px solid ${alpha(theme.palette.divider, 0.3)}`,
                  boxShadow: '0 30px 60px rgba(0,0,0,0.5)',
                },
              },
            }}
          >
            {/* Título */}
            <DialogTitle
              sx={{
                fontWeight: 700,
                textAlign: 'center',
                color: theme.palette.success.main,
                letterSpacing: 0.3,
              }}
            >
              Cambio de contraseña
            </DialogTitle>

            {/* Mensaje */}
            <DialogContent sx={{ textAlign: 'center', pt: 1 }}>
              <Typography variant="body1" color="text.primary">
                Contraseña actualizada con éxito.
                <br />
                Ingrese con su nueva contraseña.
              </Typography>
            </DialogContent>

            {/* Acción */}
            <DialogActions sx={{ justifyContent: 'center', pb: 2 }}>
              <Button
                variant="contained"
                color="success"
                onClick={() => {
                  setOpenPasswordSuccess(false);

                  // 🧹 limpieza final del flujo
                  setShowModal(false);
                  setCodeVerified(false);
                  setNewPassword('');
                  setConfirmPassword('');
                  setEnteredCode(['', '', '', '', '', '']);
                  setuniqueId('');
                }}
                sx={{
                  px: 4,
                  borderRadius: 2,
                  fontWeight: 600,
                }}
              >
                Entendido
              </Button>
            </DialogActions>

            <Divider />

            {/* Footer marca */}
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                gap: 1,
                py: 1.5,
                opacity: 0.75,
              }}
            >
              <RiVideoFill size={18} color="#F5A53D" />
              <Typography variant="caption" color="text.secondary">
                OverWatch
              </Typography>
            </Box>
          </Dialog>

        </Box>
      </Box>

      {/* Registro de Incorporación exitoso */}
      <Dialog
        open={openRegistroSuccess}
        onClose={(_, reason) => {
          if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
            setOpenRegistroSuccess(false);
          }
        }}
        maxWidth="xs"
        fullWidth
        slotProps={{
          paper: {
            sx: {
              backgroundColor: '#202020',
              border: '1px solid rgba(148,163,184,0.25)',
              color: '#e5e7eb',
              minWidth: 360,
            },
          },
        }}
      >
        {/* Título */}
        <DialogTitle
          sx={{
            fontWeight: 800,
            textAlign: 'center',
            color: 'success.main',
            letterSpacing: 0.4,
          }}
        >
          Registro completado
        </DialogTitle>

        {/* Mensaje */}
        {registroSuccessTipo === 'cliente' ? (
          <DialogContent sx={{ textAlign: 'center', pt: 1 }}>
            <Typography
              variant="body2"
              sx={{
                lineHeight: 1.6,
                color: 'text.secondary',
              }}
            >
              El cliente fue registrado correctamente.
              <br />
              Ya puede acceder a la plataforma con sus credenciales.
            </Typography>
          </DialogContent>
        ) : (
          <DialogContent sx={{ textAlign: 'center', pt: 1 }}>
            <Typography
              variant="body2"
              sx={{
                lineHeight: 1.6,
                color: 'text.secondary',
              }}
            >
              El Cliente/Proveedor fue registrado correctamente.
              <br />
              Gracias por registrase a Overwatch.
            </Typography>
          </DialogContent>
        )}

        {/* Acción */}
        <DialogActions sx={{ justifyContent: 'center', pb: 2 }}>
          <Button
            variant="contained"
            color="success"
            sx={{
              px: 4,
              borderRadius: 2,
              fontWeight: 600,
            }}
            onClick={() => {
              setOpenRegistroSuccess(false);
              setRegistroSuccessTipo(null);
            }}
          >
            Entendido
          </Button>
        </DialogActions>

        <Divider />

        {/* Marca */}
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            gap: 1,
            py: 1.5,
            opacity: 0.75,
          }}
        >
          <RiVideoFill size={18} color="#F5A53D" />
          <Typography variant="caption" color="text.secondary">
            OverWatch
          </Typography>
        </Box>
      </Dialog>

    </ThemeProvider>
  );
};
export default Login;
